import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const copy = (props) => (
  <SvgIcon width="13.818" height="16" viewBox="0 0 13.818 16" {...props}>
    <path
      d="M12.182,1H3.455A1.459,1.459,0,0,0,2,2.455V12.636H3.455V2.455h8.727Zm2.182,2.909h-8A1.459,1.459,0,0,0,4.909,5.364V15.545A1.459,1.459,0,0,0,6.364,17h8a1.459,1.459,0,0,0,1.455-1.455V5.364A1.459,1.459,0,0,0,14.364,3.909Zm0,11.636h-8V5.364h8Z"
      transform="translate(-2 -1)"
    />
  </SvgIcon>
);
export default copy;



// WEBPACK FOOTER //
// ./src/common/icons/Copy/index.tsx